module.exports = __webpack_public_path__ + "img/historie.1b6ca3d9.webp";